
import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap';
import { connect } from 'react-redux'
import { setGlobalLoading } from 'redux/actions/actionCommon'
import { getToken } from 'utlis/Apis/QuickBooks_API';
import useQueryHook from 'utlis/CustomHooks/useQueryHook';
import { getFromLocalStorage, saveToLocalStorage } from 'utlis/helpers/Common/CommonHelperFunctions';

function QucikBooksConnect(props) {
    let query = useQueryHook();
    const [error, setError] = useState(null)
    const [connecting, setConnecting] = useState(true)

    useEffect(() => {
        const qb_ref_token = getFromLocalStorage("qb_ref_token")
        if (qb_ref_token) {
            setConnecting(false)
            props.history.push('/settings/integration/quickbooks/settings')
        } else {
            const code = query.get("code")
            const realmId = query.get("realmId")
            const state = query.get("state")
            if (!code || !realmId) {
                setConnecting(false)
                setError("Something went wrong.")
            } else if (connecting) {
                getToken(props.currentUser.userToken, { code, realm_id: realmId, state }).then(res => {
                    onSuccess(res.data)
                }).catch(e => {
                    console.log("error", e)
                })
            }
        }
    }, [props.currentUser.userToken, query])

    const onSuccess = (res) => {
        setConnecting(false)
        if (res.success && res.data) {
            saveToLocalStorage("qb_token", res.data.refresh_token);
            saveToLocalStorage("qb_ref_token", res.data.access_token);
            saveToLocalStorage("qb_realm_id", res.data.realm_id);
            props.history.push('/settings/integration/quickbooks/settings')
        } else {
            setError(res.message || "Something went wrong.")
        }
    }
    return (
        <section id="app-integration-details" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                {connecting ? "connecting.." : (!error ?
                    <div>"Connected"<br />
                        {/* <Link to="/settings/integration/quickbooks/settings" className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-15">
                            <FeatherIcon
                                icon="settings"
                                size="14"
                                className="icon me-1" />
                            <span>Settings</span>
                        </Link> */}

                    </div>
                    : error)}
            </Container >
        </section >
    )
}

const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(QucikBooksConnect)